module.exports = __webpack_public_path__ + "media/lots.c4b3f4de.jpg";